import React from 'react';
import { BEIAN_COPYRIGHT_TEXT, BEIAN_URL } from '../config/beian';

interface BeianLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  text?: string;
}

export default function BeianLink({ text = BEIAN_COPYRIGHT_TEXT, style, ...props }: BeianLinkProps) {
  return (
    <a
      href={BEIAN_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: 'inherit',
        textDecoration: 'none',
        ...style,
      }}
      {...props}
    >
      {text}
    </a>
  );
}
